import { useEffect } from 'react';

import { ensureGtag } from 'utils/analytics';

/**
 * GoogleAnalytics injects the GA4 code using the measurement ID from Vite env.
 * Usage: Place <GoogleAnalytics /> once at the top level of your app (e.g., in App.jsx).
 */
export default function GoogleAnalytics() {
  useEffect(() => {
    const measurementId = import.meta.env.VITE_APP_GA_MEASUREMENT_ID;
    if (!measurementId) return;

    // Prevent duplicate injection
    if (document.getElementById('ga-script')) return;

    // Una sola definición de window.gtag para toda la app, en utils/analytics.
    // La que vivía acá empujaba un Array al dataLayer en vez del objeto `arguments`, que es
    // lo que gtag.js lee. Nunca llegó a hacer daño: app/router.tsx corre a nivel de módulo,
    // antes de cualquier render, y ya definía la versión correcta, así que el `if (!window
    // .gtag)` de acá nunca entraba. Era código inalcanzable y equivocado a la vez; se unifica
    // para que no vuelva a ser alcanzable por un cambio de orden de imports.
    ensureGtag();

    // Inject the GA4 script
    const script = document.createElement('script');
    script.id = 'ga-script';
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    document.head.appendChild(script);

    // Inject configuration
    const initScript = document.createElement('script');
    initScript.id = 'ga-init-script';
    initScript.innerHTML = `
      gtag('js', new Date());
      // send_page_view is false because the router subscriber manually handles page views
      // in routes/index.jsx to avoid sending PII (query params)
      gtag('config', '${measurementId}', { send_page_view: false });
    `;
    document.head.appendChild(initScript);

    return () => {
      // Cleanup on unmount
      script.remove();
      initScript.remove();
    };
  }, []);

  return null;
}
